export default function RepostFields({ v, setV, set }) {
  const stock = v.has_variants ? v.variants.reduce((a, x) => a + (Number(x.qty) || 0), 0) : Number(v.stock_total) || 0;
  const allowed = stock > 0;
  const on = allowed && v.repost_enabled;
  return (
    <div className="repost-box" data-testid="repost-fields">
      <label className={`check${allowed ? "" : " disabled"}`}>
        <input type="checkbox" checked={on} disabled={!allowed} onChange={set("repost_enabled")} data-testid="offer-repost-toggle" /> Læg op igen, hvis der
        er varer tilbage
      </label>
      {!allowed && <div className="hint" data-testid="repost-needs-stock">Kræver et lager-antal</div>}
      {on && (
        <div className="repost-fields">
          <div className="field" style={{ maxWidth: 200 }}>
            <label htmlFor="repost_days">Efter antal dage</label>
            <input id="repost_days" type="number" min={1} max={14} value={v.repost_days}
              onChange={(e) => setV((s) => ({ ...s, repost_days: e.target.value }))} data-testid="offer-repost-days" />
          </div>
          <div className="hint">Tælles fra sidste afhentningsdag. Du får et forslag, som du selv skal godkende – der slås aldrig noget op automatisk. Højst 3 genopslag.</div>
          <div className="field">
            <label htmlFor="repost_text">Tekst til genopslag</label>
            <textarea id="repost_text" maxLength={1500} required value={v.repost_text} onChange={set("repost_text")}
              placeholder="Fx: Vi har stadig nogle tilbage – skriv ja tak!" data-testid="offer-repost-text" />
          </div>
        </div>
      )}
    </div>
  );
}
